// event.data - the object that the iframe sent us
// event.origin - the URL from which the message came
// event.source - a reference to the 'window' object that sent the message
( function ( $ ) {
	window.addEventListener( 'message', function ( e ){
		if ( ( e.data.callback ?? null ) == 'resize' ) {
			let slashless = e.source.location.href.replace( /\/$/, '' );
			let $frame = $( `iframe[src='${ slashless }'], iframe[src='${ slashless }/']` );
			if ( $frame.length ) {
				$frame.height( parseInt( e.data.dimensions.height ) );
			}
		}
	}, false );
})( jQuery );